import type { NotYetCopy } from "./portal.ts";

/**
 * A destination that exists in the sidebar and not yet in the registry.
 *
 * Reachable rather than disabled, and specific rather than "coming soon".
 * Several of these are waiting on a decision recorded in
 * docs/accessFGARules.md under Deliberately absent, and a user told "sales need
 * a transfer, which is an offer one side makes and the other accepts"
 * understands the product better than one told nothing.
 *
 * Takes the copy rather than looking it up: which portal's spec it came from is
 * the shell's business, not this component's.
 */
export function NotBuiltYet({ copy }: { copy: NotYetCopy | null }) {
  if (!copy) return null;

  return (
    <section className="shell__notyet">
      <h2 className="shell__notyet-lead">{copy.lead}</h2>
      <p className="shell__notyet-detail">{copy.detail}</p>
    </section>
  );
}
